// extracted by mini-css-extract-plugin
export default {"basic-panel":"BasicPanel_basic-panel__PdPkh","title":"BasicPanel_title__iWdGW","with-logo":"BasicPanel_with-logo__UmQhY","with-back":"BasicPanel_with-back__42eoc"};